import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async ({
    linkId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(`${URLS.das.utableShare.shareOption}/${linkId}`, {}, options);
    if (error) return { error, status };
    return content || {};
};
